import "./privacyandterms.scss";
import React, { useEffect } from "react";

function Terms() {
  useEffect(() => {
    document.body.style.backgroundColor = 'white';
    const script = document.createElement("script");

    script.id = "termly-jssdk";
    script.src = "https://app.termly.io/embed-policy.min.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <div name="termly-embed" data-id="7dc98816-79c7-4d4b-9ae5-0b048a429e1e" data-type="iframe"></div>
    </div>
  );
}

export default Terms;
